import { useCallback } from "react";
import { useState } from "react";

export const useToggleState = (init = false) => {
  const [state, setState] = useState(init);

  const toggle = useCallback(
    (val = false) => setState((prev) => val || !prev),
    []
  );

  return [state, toggle];
};
